<template>
  <div>
    <!-- Header -->
    <div class="header bg-home py-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">

          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <section id="intro-content">
      <div class="container">

        <base-progress style="width: 80%; margin: auto" show-label type="secondary" label="Progresso" :height="4" :value="progressValue" ></base-progress>
        <div class="py-4">
          <div class="icon-category">
            <div class="bg-home">
              <small>PERGUNTAS</small>
            </div>
          </div>
          <h2 class="display-3 pt-2">Parte 3</h2>
          <p class="lead">Coloque o seletor na posição que mais representa sua opinião sobre o que está sendo dito.</p>
          <p><b>ATENÇÃO:<br />Responda com sinceridade para obter o resultado mais adequado</b></p>
        </div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form id="qa1" class="needs-validation qa"
                @submit.prevent="handleSubmit(nextPage)">


            <div class="form-row">
              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Gosto muito de música; curto peças de teatro, exposições; adoro
                    visitar museus e compreender um pouco mais sobre cultura e
                    história.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p3.q11">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Não suporto coisas “meia-boca”. Dou sempre o melhor de mim,
                    se é pra fazer que seja muito bem feito. Sou persistente em tudo o
                    que faço e não paro antes de terminar.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p3.q12">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Tenho um caderninho onde eu anoto tudo o que já realizei e tudo
                    o que eu ainda pretendo realizar. Costumo planejar o que quero e o
                    que vou fazer para conquistar o que pretendo.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p3.q13">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Nunca acreditei que o melhor é arrumar um emprego de carteira
                    assinada, ou passar num concurso público que vai me garantir um
                    valor fixo por mês até o final da minha vida.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p3.q14">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Procuro sempre me atualizar sobre os assuntos. Estudo todos
                    os dias, leio artigos, assisto a vídeos e compro livros da área na
                    qual tenho interesse.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p3.q15">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="align-center mt-6">
              <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
              <base-button type="secondary" native-type="submit">Avançar</base-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
    <!-- Page content -->


  </div>
</template>

<script>
import 'vue-range-slider/dist/vue-range-slider.css'
import RangeSlider from 'vue-range-slider'

export default {
  name: 'qa3',
  components: {
    RangeSlider,
  },
  data: () => ({
    validated: false,
    slider: 0,
    progressValue: 70,
    p3: {
      q11: 1,
      q12: 1,
      q13: 1,
      q14: 1,
      q15: 1,
    },
  }),
  methods: {
    prevPage () {
      this.$router.push('qa2')
    },
    update () {
      window.localStorage.setItem("p3", JSON.stringify(this.p3))
    },
    async nextPage () {
      window.localStorage.setItem("p3", JSON.stringify(this.p3))
      console.log(this.p3)
      let sum = this.p3.q11+this.p3.q12+this.p3.q13+this.p3.q14+this.p3.q15
      window.localStorage.setItem("p3sum", JSON.stringify(sum))
      await this.$router.push('lastinfo')
    }

  },
  created() {
    let payload = window.localStorage.getItem("p3")

    if (payload != null) {
      this.p3 = JSON.parse(payload)
    }

  }
};
</script>
<style></style>
